import { put, call, takeLatest, all } from "redux-saga/effects";
import * as Api from "./activityFormApi";
import {
  fetchSkillsetTagsRequest,
  fetchSkillsetTagsSuccess,
  fetchSkillsetTagsError,
} from "./skillsetTagsSlice";

function normalize(raw) {
  if (!raw) return [];
  const list = Array.isArray(raw) ? raw : (raw.Data ?? raw.data ?? raw.skillset ?? []);
  return list.map((tag) =>
    typeof tag === "string"
      ? { id: tag, text: tag }
      : {
          id: tag.id ?? tag.Id ?? tag.name ?? tag.Name,
          text: tag.text ?? tag.name ?? tag.Name ?? String(tag.id ?? ""),
        },
  );
}

function* fetchSkillsetTagsSaga() {
  try {
    const response = yield call(Api.fetchSkillsetTags);
    yield put(fetchSkillsetTagsSuccess(normalize(response)));
  } catch (error) {
    yield put(
      fetchSkillsetTagsError(error?.message || "Failed to fetch skillset tags"),
    );
  }
}

export default function* skillsetTagsSaga() {
  yield all([takeLatest(fetchSkillsetTagsRequest.type, fetchSkillsetTagsSaga)]);
}